import styled from "styled-components";
import pxIntoRem from "../../utils/pxIntoRem";

const IndexBlock = styled.div`
  dispaly: flex;
  flex-direction: column;
  width: 100%;
`;

export { IndexBlock };
